import AutoHighlightBlock from './AutoHighlightBlock';

export default AutoHighlightBlock;
